class ConsumersGridController  {
    constructor($session, $window, $state) {
        this.$state = $state;
    }
    edit(consumer) {
        this.container.edit(consumer);
    }
    delete(consumer) {
        this.container.delete(consumer);
    }
    add() {
        this.container.add();
    }
}

let ConsumersGrid = {
    bindings: {
        query: '<',
        onAdd: '&',
        onDelete: '&',
        onUpdate: '&'
    },
    require: {
        container: '^consumersContainer'
    },
    controller: ConsumersGridController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumers-grid.html'
    }
}

angular.module('emun.consumer').component('consumersGrid', ConsumersGrid);
